import { Component, Input, Output, EventEmitter } from '@angular/core';
import { I18NDescriptor } from '../../uikit.interface';

@Component({
  selector: 'va-filter-chip',
  templateUrl: './va-filter-chip.component.html',
  styleUrls: ['./va-filter-chip.component.scss'],
})
export class VaFilterChipComponent {
  @Input() title: I18NDescriptor;
  @Input() canDisable?: boolean;
  @Input() icon?: string;
  @Input() text?: I18NDescriptor;
  @Input() id?: string;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onClick = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDelete = new EventEmitter();

  emitClickEvent(event: MouseEvent): void {
    event.stopPropagation();
    this.onClick.emit(event);
  }

  emitDeleteEvent(event: MouseEvent): void {
    event.stopPropagation();
    this.onDelete.emit(event);
  }
}
